module.exports = __webpack_public_path__ + "static/img/XA20.0dd9d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XA20.png
// module id = 7dQ+
// module chunks = 2